module.exports = __webpack_public_path__ + "img/Picture3.d3474ea7.jpg";